<template>
  <div>
    <!-- Background image -->
    <div class="mainBackground">
      <!-- Banner -->
      <CRow style="width:100%;">
        <CCard style="width: 100%;margin: 5rem 2rem auto;border:0;background-color:transparent;">
          <CCardHeader class="cardheader">
            <h4 class="topictext">Learning Profile</h4>
          </CCardHeader>
          <CCardBody
            style="width:'100%'
          background: #FFFFFF 0% 0% no-repeat padding-box;
          box-shadow: 0px 0px 30px #00000029;
          border-radius: 20px;
          opacity: 1;
          backdrop-filter: blur(40px);
          -webkit-backdrop-filter: blur(40px);
          margin-left: 30px;"
          >
            <CRow>
              <CCol xl="2" style="display: flex;justify-content: center;">
                <img class="alligator-turtle" :src="userProfile.userinfo.userinfo.image_profile" />
              </CCol>
              <CCol xl="3">
                <div style="text-align:center;">
                  <br />
                  <br />
                  <b
                    class="TopicName"
                  >{{userProfile.userinfo.userinfo.firstname[0].val}} {{userProfile.userinfo.userinfo.lastname[0].val}}</b>
                  <p>{{userProfile.codeId}}</p>
                </div>
                <div class="boxs" style="width: 22rem;">
                  <div class="boxcss">
                    <p class="TopicNumber">Enrolled</p>
                    <b
                      class="Numberinformation"
                    >{{userCourse.enrolls.length + userCourse.inprogress.length}}</b>
                    <b
                      class="Numberinformation"
                      v-if="userCourse.enrolls.length + userCourse.inprogress.length === null"
                    >0</b>
                  </div>
                  <div class="boxcss">
                    <p class="TopicNumber">In Progress</p>
                    <b class="Numberinformation">{{userCourse.inprogress.length}}</b>
                    <b class="Numberinformation" v-if="userCourse.inprogress.length === null">0</b>
                  </div>
                  <div class="boxcss">
                    <p class="TopicNumber">Completed</p>
                    <b
                      style="color: #44BF9E;"
                      class="Numberinformation"
                    >{{userCourse.enrolls.length}}</b>
                    <b
                      style="color: #44BF9E;"
                      class="Numberinformation"
                      v-if="userCourse.enrolls.length === null"
                    >0</b>
                  </div>
                  <div class="boxcss">
                    <p class="TopicNumber">Unenrolled</p>
                    <!-- <b
                      style="color: #BD2531;"
                      class="Numberinformation"
                    >{{userCourse.unenrolls[0].unenrolled_number}}</b>-->
                    <!-- <b
                      style="color: #BD2531"
                      class="Numberinformation"
                      v-if="userCourse.unenrolls[0].unenrolled_number === null"
                    >0</b>-->
                    <b style="color: #BD2531" class="Numberinformation">0-0</b>
                  </div>
                </div>
              </CCol>

              <CCol xl="7" lg="7" sm="12" md="12">
                <div style="display:flex;height:25px">
                  <b class="textViewall2">MY CERTIFICATE</b>
                  <router-link to class="textViewall">VIEW ALL</router-link>
                </div>
                <div class="photo3" id="test">
                  <div
                    v-for="(item, index) in userCourse.certificate[0].certificateId.certificateImage "
                    :key="index"
                  >
                    <img
                      class="imageoverview"
                      :src="userCourse.certificate[0].certificateId.certificateImage[index].url"
                    />
                  </div>
                  <h1
                    class="nodata"
                    v-if="userCourse.certificate[0].certificateId.certificateImage.length === 0"
                  >No data</h1>
                </div>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CRow>
      <br />
      <!-- ----------------------------------------------- Course Name --------------------------------------------------------------------- -->
      <div class="ml-5 mt-3">
        <CRow>
          <CCol xl="12" lg="6" md="6" sm="6">
            <h4 class="topictext">Course Name</h4>
            <p>Progressing</p>
          </CCol>
        </CRow>
        <br />
        <!-- Right Button -->
        <br />
        <div class="containerDanger" style="height: 22rem;">
          <div
            class="wrapper"
            id="content-free"
            ref="contentFree"
            style="margin-top: -31px;height:auto;"
          >
            <div class="itemC" v-for="(item, index) in cardItem" :key="index">
              <topicCard :data="sentData" />
            </div>
          </div>
        </div>
      </div>
      <!-- ----------------------------------------------- Course Name --------------------------------------------------------------------- -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Service from "../../service/api";
import courseCardfavotire from "../showSingleCard/CourseCardfavorite";
import topicCard from "../showSingleCard/TopicCard";
import courseCard from "../showSingleCard/CourseCardProgress";
import courseComplete from "../showSingleCard/CourseCardComplete";
import courseCardSuggest from "../showSingleCard/CourseCardSuggest";
import prototype from "../showSingleCard/Prototype";
import prototypecomplete from "../showSingleCard/PrototypeComplete";

export default {
  props: {
    data: Object,
  },
  data() {
    return {
      cardItem: [],
      interval: 6000,
      course: "",
      newCourse: "",
      userProfile: [],
      userCourse: [],
      codeID: "",
      sentData: {
        status: true,
      },
    };
  },
  components: {
    courseCardfavotire,
    topicCard,
    courseCard,
    courseComplete,
    courseCardSuggest,
    prototype,
    prototypecomplete,
  },
  created() {
    this.fetchCourses();
    this.onLoadUserInfo();
  },
  methods: {
    /**
     * scrollTo - Horizontal Scrolling
     * @param {(HTMLElement ref)} element - Scroll Container
     * @param {number} scrollPixels - pixel to scroll
     * @param {number} duration -  Duration of scrolling animation in millisec
     */

    onLoadUserInfo() {
      let payload = {
        token: localStorage.getItem("token"),
      };
      this.$store.dispatch("fetchUserDataByToken");
    },

    fetchCourses() {
      // this.$store.dispatch("fetchCourses");
      Service.fetchCourses()
        .then((res) => {
          this.cardItem = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    scrollTo(element, scrollPixels, duration) {
      const scrollPos = element.scrollLeft;
      // Condition to check if scrolling is required
      if (
        !(
          (scrollPos === 0 || scrollPixels > 0) &&
          (element.clientWidth + scrollPos === element.scrollWidth ||
            scrollPixels < 0)
        )
      ) {
        // Get the start timestamp
        const startTime =
          "now" in window.performance
            ? performance.now()
            : new Date().getTime();

        function scroll(timestamp) {
          //Calculate the timeelapsed
          const timeElapsed = timestamp - startTime;
          //Calculate progress
          const progress = Math.min(timeElapsed / duration, 1);
          //Set the scrolleft
          element.scrollLeft = scrollPos + scrollPixels * progress;
          //Check if elapsed time is less then duration then call the requestAnimation, otherwise exit
          if (timeElapsed < duration) {
            //Request for animation
            window.requestAnimationFrame(scroll);
          } else {
            return;
          }
        }

        //Call requestAnimationFrame on scroll function first time
        window.requestAnimationFrame(scroll);
      }
    },
    swipeLeft() {
      const content = this.$refs.content;
      this.scrollTo(content, -300, 800);
    },
    swipeRight() {
      const content = this.$refs.content;
      this.scrollTo(content, 300, 800);
    },
    swipeLeftNew() {
      const content = this.$refs.contentNew;
      this.scrollTo(content, -300, 800);
    },
    swipeRightNew() {
      const content = this.$refs.contentNew;
      this.scrollTo(content, 300, 800);
    },
    swipeLeftFree() {
      const content = this.$refs.contentFree;
      this.scrollTo(content, -300, 800);
    },
    swipeRightFree() {
      const content = this.$refs.contentFree;
      this.scrollTo(content, 300, 800);
    },
    swipeLeftGod() {
      const content = this.$refs.contentGod;
      this.scrollTo(content, -300, 800);
    },
    swipeRightGod() {
      const content = this.$refs.contentGod;
      this.scrollTo(content, 300, 800);
    },
    bannerNav(navigation) {
      alert("Go to: " + navigation);
    },
  },
  computed: {
    ...mapGetters([
      "allCourses",
      "getNewCourse",
      "userProfileGetter",
      "userCourseGetter",
    ]),
  },
  watch: {
    // allCourses: function(val) {
    //   this.course = val;
    // },
    getNewCourse: function (val) {
      this.newCourse = val;
    },
    userProfileGetter: function (val) {
      this.userProfile = val;
      if (this.userProfile.codeId == null) {
        this.codeID = "คนธรรมดา";
      } else {
        this.codeID = this.userProfile.codeId;
      }
    },
    userCourseGetter: function (val) {
      this.userCourse = val;
      this.certificateList = this.userCourse.certificate[0].certificateId.certificateImage;
    },
  },
};
</script>

<style scoped>
.mainBackground {
  overflow: hidden;
  background-image: url("../../assets/icons/bg_learning.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  height: 100%;
}

.viewAllText:hover {
  cursor: pointer;
}

.containerDanger {
  position: relative;
  width: 100%;
  height: 230px;
}

.containerDanger .wrapper {
  float: left;
  width: 100%;
  height: 100%;
  margin: 1px;
  overflow: hidden;
}

.containerDanger .wrapper .viewAllIconContainer {
  text-align: center;
  height: 220px;
  line-height: 220px;
}

.containerDanger .wrapper .viewAllIconContainer img {
  vertical-align: middle;
}

.containerDanger .wrapper .viewAllIconContainer:hover {
  cursor: pointer;
}

/* ปิด scrollbar ไว้ */
/* .containerDanger .wrapper::-webkit-scrollbar {
  display: none;
} */

.containerDanger .wrapper .itemC {
  height: 100%;
  bottom: 0;
  display: inline-block;
}

.containerDanger .left {
  margin-top: 1px;
  height: 100%;
  text-align: center;
  z-index: 1;
  position: absolute;
  left: 0;
  width: 3%;
  color: white;
  background: black;
  opacity: 0.2;
}

.containerDanger .right {
  margin-top: 1px;
  height: 100%;
  text-align: center;
  z-index: 1;
  position: absolute;
  right: 0;
  width: 3%;
  background: black;
  color: white;
  opacity: 0.2;
}

.containerDanger .left:hover,
.containerDanger .right:hover {
  cursor: pointer;
  opacity: 0.6;
  background: grey;
}

.carousel.carousel-fade .carousel-item {
  transition: opacity linear 0.6s;
}

.carousel-fade .carousel-item .imgContainer {
  max-height: 70vh;
}

.carousel-fade .carousel-item .imgContainer img {
  width: 100%;
  height: 70vh;
}

.Numberinformation {
  text-align: left;
  font: Bold 30px/39px Roboto;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
}

.textViewall {
  margin-left: auto;
  margin-right: 30px;
  font: Bold 14px/19px Roboto;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
  margin-top: 4px;
}
.textViewall2 {
  font: Bold 14px/19px Roboto;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
  margin-top: 4px;
}
/* -- ----------------------------------------------------------CSS Copy-------------------------------------------------- -- */

.content {
  margin-top: auto;
  margin-bottom: auto;
}

.photo3 {
  width: 100%;
  height: 205px;
  overflow-x: scroll;
  display: flex;
}
.imageoverview {
  width: 240px;
  height: 180px;
  background: transparent;
  box-shadow: 5px 5px 6px #00000029;
  border-radius: 10px;
  opacity: 1;
  margin-right: 10px;
}
.boxs {
  display: flex;
  width: 300px;
  height: 100px;
  justify-content: center;
}
.boxcss {
  width: 80px;
  height: 60px;
  border: 1px solid white;
  margin-left: 3px;
  font-size: 14px;
  text-align: center;
  background-color: white;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 5px 5px 5px #00000029;
  border-radius: 10px;
  opacity: 1;
  margin: 5px;
}
/* ---------------------------------------------------CSS scrollbar---------------------------------------------------------------------  */
/* width */

::-webkit-scrollbar {
  height: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #959595;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #959595;
}
/* ---------------------------------------------------CSS scrollbar---------------------------------------------------------------------  */

.button {
  outline: none;
  border: none;
  width: 12rem;
  text-align: center;
  padding-top: 5px;
  padding-bottom: 5px;
  border-radius: 40px;
  font-size: 16px;
  margin: 10px;
}
.cardheader {
  background-color: transparent;
  border: 0px;
  margin-left: 12px;
}
.drobdown_modal {
  width: 90%;
  border: 0px;
  border-bottom: 1px solid #cccccc;
  margin-left: 20px;
}

.modal-text p {
  font-weight: 300;
  font-size: 16px;
  color: black;
  margin-bottom: 0px;
}

.modal-text h1 {
  font-family: "Roboto", sans-serif;
  font-weight: 600;
  font-size: 24px;
  color: black;
  text-align: center;
}
.card-body {
  padding: 0px;
}
/* ------------------------------------------------------- VILL all next page ------------------------------------------------------ */

/* background border */
.sign-in-inactive {
  background: rgba(204, 204, 204, 0.5);
  border-top-left-radius: 30px;
  border-bottom-right-radius: 30px;
}

.sign-in-inactive::before {
  -webkit-filter: blur(5px);
  -moz-filter: blur(5px);
  -o-filter: blur(5px);
  -ms-filter: blur(5px);
  filter: blur(50px);
}

.sign-up-inactive {
  background: rgba(204, 204, 204, 0.5);
  border-top-right-radius: 30px;
  border-bottom-left-radius: 30px;
}

.sign-up-inactive::before {
  -webkit-filter: blur(5px);
  -moz-filter: blur(5px);
  -o-filter: blur(5px);
  -ms-filter: blur(5px);
  filter: blur(50px);
}

.text-wrapper {
  position: relative;
  color: #000000;
  width: 100%;
  text-transform: uppercase;
  text-align: center;
  font-weight: 500;
  font-family: "Roboto", Medium;
}

#app .container.button button {
  color: red !important;
}

.modal-content p {
  font-size: 24px;
  margin-top: 0.6em;
}

#info-block section {
  border-top: 1px solid white;
  text-align: center;
}

.file-marker > div {
  padding: 0 3px;
  margin-top: -0.9em;
}

.tab {
  border-top-right-radius: 30px;
  border-top-left-radius: 30px;
  border-bottom-right-radius: 30px;
  border-bottom-left-radius: 30px;
}

a {
  text-decoration: none;
}

.nav-link {
  border: none;
}

.nav-tabs {
  border: none;
}

/* -------------------------------------------------------------- modal new --------------------------------------------------------- */

.alligator-turtle {
  object-fit: cover;
  width: 225px;
  height: 235px;
  box-shadow: 5px 5px 6px #00000029;
  border-radius: 10px;
  opacity: 1;
}

.topictext {
  text-align: left;
  font: Bold 30px/39px Roboto;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
  font-family: Roboto;
  font-weight: bold;
}
/* --------------------------------------------------------------------NEW CSS-------------------------------------------------------------------- */

.TopicName {
  /* text-align: left; */
  font-size: 24px;
  font: Medium 24px/32px Roboto;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
}
.TopicNumber {
  margin-bottom: 0px;
  font: Regular 16px/21px Roboto;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
}
.nodata {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 5rem;
  opacity: 0.4;
}
</style>

